/**
 * libraryDuration.js — story 167 (D9 · RN-06.10, D16.2). Pure. What a row of the library lasts, read from
 * what Sun publishes (03-dominio.md §7: C1 `totalTimeMs`, C2 and C3 `timeMs`) and painted as Tree paints its
 * Duration column. Jupiter never computes the time of a library row; it only adds up a subprocess.
 */
import { GetAccumulatedUtcTime, GetUtcTime } from '../../generic/DateTimeFunctions'

export const DURATION_DASH = '—'

/** Absent, null, zero or not a number: unknown, which the rows paint as a dash, never as 00:00:00. */
export const contractDurationMs = (value) => (typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : 0)

export const operationDurationText = (ms) => (ms > 0 ? GetUtcTime(ms) : DURATION_DASH)

export const aggregateDurationText = (ms) => (ms > 0 ? GetAccumulatedUtcTime(ms) : DURATION_DASH)

/**
 * RN-06.10: an unfolded subprocess lasts what the operations hanging from it last, at any depth, each node
 * once. With a branch inside that could not be read, the total is not given as if it were whole: 0 (dash).
 */
export const subprocessDurationMs = (row) => {
  const seen = new Set()
  let total = 0
  let readable = !row.unreadable
  const walk = (children) => {
    (children || []).forEach((child) => {
      if (child.unreadable) {
        readable = false
        return
      }
      if (child.nodeType === 'JOB' && !seen.has(child.nodeId)) {
        seen.add(child.nodeId)
        total += child.timeMs
      }
      walk(child.children)
    })
  }
  walk(row.children)
  return readable ? total : 0
}
